import { render, staticRenderFns } from "./InternalComment.vue?vue&type=template&id=229474d0"
import script from "./InternalComment.vue?vue&type=script&lang=ts"
export * from "./InternalComment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports